import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_entity_component = _resolveComponent("g-entity-component");
    const _component_g_entity_modal = _resolveComponent("g-entity-modal");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx._self)
            ? (_openBlock(), _createBlock(_component_g_entity_component, {
                key: 0,
                window: _ctx._self
            }, null, 8, ["window"]))
            : _createCommentVNode("", true),
        (_ctx._modals)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx._modals, (window) => {
                return (_openBlock(), _createBlock(_component_g_entity_modal, { window: window }, null, 8, ["window"]));
            }), 256))
            : _createCommentVNode("", true)
    ], 64));
}
